import React, { useCallback } from 'react';
import Pagination from 'react-bootstrap/Pagination';
var PaginationItemWrapper = function (_a) {
    var page = _a.page, onClick = _a.onClick;
    var handleClick = useCallback(function () { return onClick(page); }, [onClick, page]);
    return React.createElement(Pagination.Item, { href: "#", onClick: handleClick }, page + 1);
};
export default React.memo(PaginationItemWrapper);
